import React, { Component } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';

export default class Button extends Component {
    render() {
        const {
            url,
            label,
            children,
            disable,
            acid,
            ...props
        } = this.props;
        const styles = cx('cc-button', {
            'cc-button--disable': disable,
            'cc-button--acid': acid
        });
        return (
            <React.Fragment>
                {
                    url && !disable
                    ? <Link to={url} className={styles} {...props}>
                            {label || children}
                        </Link>
                    : <button className={styles} {...props}>
                        {label || children}
                    </button>
                }
            </React.Fragment>
        )
    }
};



// WEBPACK FOOTER //
// ./src/base/components/Button/index.js